import CreditLine from "../images/line-credit.png";
import EarnedWage from "../images/earned-wage.png";
import PersonalLoan from "../images/personal-loan.png";
import p1 from "../images/p1.svg";
import p2 from "../images/p2.svg";
import p3 from "../images/p3.svg";
import p4 from "../images/p4.svg";
import s1 from "../images/s1.svg";
import s2 from "../images/s2.svg";
import s3 from "../images/s3.svg";
import s4 from "../images/s4.svg";
import s5 from "../images/s5.svg";
import s6 from "../images/s6.svg";
import sliderImg from "../images/slider-img.svg";
import video from "../images/video.svg"

export const data = {
    heroSection : {
        title : "Our Solutions",
        data : [
            {
                title: "EARNED WAGE ACCESS",
                image : EarnedWage,
                content : "Early on-demand access to accrued earnings",
                altText: "Karmalife Financial Solution",
            },
            {
                title: "CREDIT LINE",
                image : CreditLine,
                content : "Higher limits to supplement earnings for sudden emergencies",
                altText: "Karmalife Earned Wage Access"
            },
            {
                title: "PERSONAL LOAN",
                image : PersonalLoan,
                content : "Larger loans payable over multiple installments",
                altText: "",
            },
        ]
        
    },
    partnerSection : {
        title: "Why our partners love our solutions",
        data : [
            {
                bold : "More Engagement",
                small : "25% increase in login hours",
                subTitle:"",
                altText:'Karmalife Financial Solution',
                image : p3,
                clas : "ecomm-partner"
            },
            {
                bold : "Better Retention",
                small : "20-25% less churn",
                subTitle:"",
                altText:'Karmalife Financial Solution',
                image : p1,
                clas : "",
            },
            {
                bold : "Higher Productivity",
                small : "10% boost in productivity",
                subTitle:"",
                image : p4,
                altText:'Karmalife Financial Solution',
                clas : "worker"
            },
            {
                bold : "Lower Fraud",
                small : "Reduction in misuse of Cash Handling",
                subTitle:"",
                image : p2,
                altText:'Karmalife Financial Solution',
                clas : "reduction"
            },
        ]
    },
    userSection : {
        title : "Key features",
        data : [
            {
                bold : "On-call support to handhold",
                small : "first-time digital users",
                image : s1,
                altText: 'Karmalife Fintech Solution',
                clas : "",
            },
            {
                bold : "Auto repayment",
                small : "from worker payouts",
                image : s2,
                altText: 'Karmalife Fintech Solution',
                clas : "",
            },
            {
                bold : "Web and native app user experience in",
                small : "4 local languages",
                image : s3,
                clas : "",
                altText: 'Karmalife Fintech Solution',
            },
            {
                bold : "Instant credit access,",
                small : "available 24X7",
                image : s4,
                clas : "",
            },
            {
                bold : "100% digital KYC, no",
                small : "paperwork",
                image : s5,
                clas : "",
                altText: 'Karmalife Fintech Solution',
            },
            {
                bold : "Simple & flat",
                small : "usage-based fee",
                image : s6,
                clas : "",
                altText: 'Karmalife Fintech Solution',
            },
        ],  
        buttonText : "view case study" 
    },
    appSection : {
        title : "KarmaLife App",
        placeholderText : "Enter Work Email ID",
        buttonText : "download app",
    },
    storiesSection : {
        title : "Our Transformation Stories",
        data : [
            {
                title : "John Doehhhh",
                subTitle : "employee, shadowfax",
                image : sliderImg,
                videoThumbnail : video,
                videoUrl : "https://www.youtube.com/embed/BfAHnaPNk9c?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
            },
            {
                title : "John Dooe",
                subTitle : "employee, shadowfax",
                image : sliderImg,
                videoThumbnail : video,
                videoUrl : "https://www.youtube.com/embed/U4asm9nEuqw?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
            },
            {
                title : "John Dooooe",
                subTitle : "employee, shadowfax",
                image : sliderImg,
                videoThumbnail : video,
                videoUrl : "https://www.youtube.com/embed/FLcj0K3mKE4?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
            },
            {
                title : "John Dooooe",
                subTitle : "employee, shadowfax",
                image : sliderImg,
                videoThumbnail : video,
                videoUrl : "https://www.youtube.com/embed/dAHkIvoC-uI?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
            },
            {
                title : "John Dooooe",
                subTitle : "employee, shadowfax",
                image : sliderImg,
                videoThumbnail : video,
                videoUrl : "https://www.youtube.com/embed/orlUtcVdZsE?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
            },
            {
                title : "John Dooooe",
                subTitle : "employee, shadowfax",
                image : sliderImg,
                videoThumbnail : video,
                videoUrl : "https://www.youtube.com/embed/rmpGfXHzHVA?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
            }
        ]
    }
}        